import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import {
  CONTACTS_ROUTE,
  HOME_ROUTE,
  SKILLS_ROUTE,
  WORKS_ROUTE,
} from "../../utils/constants";

import { ReactComponent as LogotypeSvg } from "../../assets/images/Logotype.svg";

const StyledHeader = styled.header`
  padding-top: 3rem;
`;

const StyledNav = styled.nav`
  margin-bottom: 3rem;
`;

const Menu = styled.ul`
  margin: 0 auto;
  display: flex;
  justify-content: center;
  gap: 5rem;
  list-style-type: none;
`;

const StyledMenuItem = styled.li`
  width: 120px;
  text-align: center;
`;

const StyledMenuLink = styled.a`
  text-transform: uppercase;
  color: #ffffff;
  text-decoration: none;
  transition: 0.2s ease-out;
  &:hover {
    color: #2f9dd9;
  }
`;

const StyledLine = styled.div`
  width: 100%;
  height: 2px;
  background: #191925;
`;

const StyledLogoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const StyledLogotypeLink = styled.a`
  flex-shrink: 0;
  text-decoration: none;
`;

export const Header = () => {
  return (
    <StyledHeader>
      <StyledNav>
        <Menu>
          <StyledMenuItem>
            <StyledMenuLink as={Link} to={HOME_ROUTE}>
              Главная
            </StyledMenuLink>
          </StyledMenuItem>
          <StyledMenuItem>
            <StyledMenuLink as={Link} to={SKILLS_ROUTE}>
              Навыки
            </StyledMenuLink>
          </StyledMenuItem>
          <StyledMenuItem>
            <StyledMenuLink as={Link} to={WORKS_ROUTE}>
              Мои работы
            </StyledMenuLink>
          </StyledMenuItem>
          <StyledMenuItem>
            <StyledMenuLink as={Link} to={CONTACTS_ROUTE}>
              Контакты
            </StyledMenuLink>
          </StyledMenuItem>
        </Menu>
      </StyledNav>
      <StyledLogoWrapper>
        <StyledLine />
        <StyledLogotypeLink as={Link} to={HOME_ROUTE}>
          <LogotypeSvg />
        </StyledLogotypeLink>
        <StyledLine />
      </StyledLogoWrapper>
    </StyledHeader>
  );
};
